import PropTypes from 'prop-types';
import React from 'react';

import MinimapPin from './MinimapPin';

const Minimap = ({locationInfos}) => {
  return (
    <div className="Minimap">
      <img
        src={require('~app/resources/images/minimap/DetailMap.png')}
        alt="Detail World Map"
      />
      {locationInfos.map(renderMarker)}
    </div>
  );
};

function renderMarker(locationInfo, index) {
  const [lon, lat] = locationInfo.location.degreeCoordinates();
  const left = (lon + 180.0) / 360.0 * 100.0;
  const bottom = (lat + 90.0) / 180.0 * 100.0;

  return (
    <div className="Minimap__markerPos"
      key={`minimap-marker-${index}`}
      style={{
        left: `${left}%`,
        bottom: `${bottom}%`,
      }}
    >
      <MinimapPin locationInfo={locationInfo}/>
    </div>
  );
}

Minimap.propTypes = {
  locationInfos: PropTypes.array.isRequired,
};

export default Minimap;



// WEBPACK FOOTER //
// ./src/components/Minimap.js